// extracted by mini-css-extract-plugin
export default {"icon":"CommentsIcon_icon__yllf5","st0":"CommentsIcon_st0__0p7Qk","st1":"CommentsIcon_st1__7QzLy","st2":"CommentsIcon_st2__i4Mv3","st3":"CommentsIcon_st3__tbWo1"};